import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicNextStep extends DesigntimeComponent {
    static staticName = "Logic: Next step";
    static staticId = "logicNextStep";
    hasRuntimeView = false;
    runtimeUrlParams = [];

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            unknownRiskLevelText: { value: "Click here to do next test" },
            unknownRiskLevelBmi: { value: "realitycheck" },
            greenText: { value: "Click here to do next green test" },
            greenBmi: { value: "realitycheck" },
            yellowText: { value: "Click here to do next yellow test" },
            yellowBmi: { value: "realitycheck" },
            redText: { value: "Click here to do next red test" },
            redBmi: { value: "realitycheck" },
        };

        this.params = {
            parameter1: { key: "url:riskLevel", value: 0 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div class='logicNextStep'></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == "url") {
            this.runtimeUrlParams.push(eventParams);
        }

        if (eventParams.id == this.id)
            return;

        if (this.params.parameter1.key != eventParams.key && "url:visitId" != eventParams.key) {
            return;
        }

        for (var i in this.runtimeUrlParams) {
            if (this.runtimeUrlParams[i].key == "url:riskLevel")
                this.createNextUrl(this.runtimeUrlParams[i].value);
        }
    }

    createNextUrl(currentRiskLevel) {
        if (currentRiskLevel == 0)
            this.eventBroker.fireValueChanged(this.id, "value", this.getNextLink(this.values.unknownRiskLevelText.value, this.values.unknownRiskLevelBmi.value));
        else if (currentRiskLevel == 1)
            this.eventBroker.fireValueChanged(this.id, "value", this.getNextLink(this.values.greenText.value, this.values.greenBmi.value));
        else if (currentRiskLevel == 2)
            this.eventBroker.fireValueChanged(this.id, "value", this.getNextLink(this.values.yellowText.value, this.values.yellowBmi.value));
        else if (currentRiskLevel == 3)
            this.eventBroker.fireValueChanged(this.id, "value", this.getNextLink(this.values.redText.value, this.values.redBmi.value));
        else {
            this.eventBroker.fireValueChanged(this.id, "value", this.getNextLink(this.values.unknownRiskLevelText.value, this.values.unknownRiskLevelBmi.value));
        }
    }

    getNextLink(linkText, linkBmi) {
        return `<a href='${this.getNextUrl(linkBmi)}'>${linkText}</a>`;
    }

    getNextUrl(nextStep) {
        var link = "Index.html?";
        for (var paramIndex in this.runtimeUrlParams) {
            if (link.substr(-1) != "&")
                link += "&";
            var param = this.runtimeUrlParams[paramIndex];
            var paramName = param.key.replace("url:", "");

            if (paramName == "bmiName") {
                link = link + `bmiName=${nextStep}`
            } else {
                link = link + `${paramName}=${param.value}`
            }
        }
        return link;
    }

    output = [
        { name: "value", type: "link" }
    ];
}

export { LogicNextStep }
